import { useState, useEffect } from "react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

// True when the Support module is enabled for the current org and the user is a member.
export function useSupportEnabled() {
  const { currentOrgId } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!currentOrgId) { setEnabled(false); setLoaded(true); return; }
    setLoaded(false);
    api.get(`/support/enabled?org_id=${currentOrgId}`)
      .then((r) => { if (alive) setEnabled(!!r.data.enabled); })
      .catch(() => { if (alive) setEnabled(false); })
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [currentOrgId]);

  return { enabled, loaded };
}
